export const suggestedAction = {
  CREATE: "CREATE",
  DEACTIVATE: "DEACTIVATE",
  REACTIVATE: "REACTIVATE",
} as const;
export type SuggestedAction =
  (typeof suggestedAction)[keyof typeof suggestedAction];

type ActionWithDescribe = {
  describe: string;
};

export type AppUserActionPart = {
  type: SuggestedAction;
  disabled: boolean;
  describe?: string;
};

export type CreateAction = {
  type: typeof suggestedAction.CREATE;
  disabled: boolean;
};

export type DeactivateAction = {
  type: typeof suggestedAction.DEACTIVATE;
  disabled: boolean;
} & ActionWithDescribe;

export type ReactivateAction = {
  type: typeof suggestedAction.REACTIVATE;
  disabled: boolean;
};

//TODO アカウントの権限変更用アクションを作る

export type AppUserAction = CreateAction | DeactivateAction | ReactivateAction;
